module.exports = __webpack_public_path__ + "img/hm.fe51443.svg";